import { createAction, createReducer } from '@reduxjs/toolkit';

import api from 'common/api';
import { AppState } from 'common/models/AppState';
import { LoginFormValues, UserProfile } from 'common/models/User';

import { startListening } from '../../../../root/store/listener-middleware';
import { selectAuth } from '../../ducks';

// Actions
export const loginActions = {
  request: createAction<LoginFormValues>('@@Login/REQUEST'),
  success: createAction<UserProfile>('@@Login/SUCCESS'),
  failure: createAction('@@Login/FAILURE'),
};

export const loginResetAction = createAction('@@Login/RESET');

// Reducers
export interface LoginState {
  error: boolean;
  loading: boolean;
  success: boolean;
}

const initialState: LoginState = {
  error: false,
  loading: false,
  success: false,
} as const;

export default createReducer(initialState, (builder) => {
  builder
    .addCase(loginActions.failure, (state) => {
      state.error = true;
    })
    .addCase(loginActions.success, (state) => {
      state.success = true;
    })
    .addCase(loginResetAction, () => initialState);
});

// Selectors
export function selectLogin(state: AppState) {
  return selectAuth(state).login;
}

export function selectLoginError(state: AppState) {
  return selectLogin(state).error;
}

// Listeners
startListening({
  actionCreator: loginActions.request,
  effect: async (action, listenerApi) => {
    listenerApi.cancelActiveListeners();
    const resp = await api.user.login(action.payload);

    if (resp.ok) {
      listenerApi.dispatch(loginActions.success(resp.data));
    } else {
      listenerApi.dispatch(loginActions.failure());
    }
  },
});
